module.exports = __webpack_public_path__ + "static/media/medal.3a07668b.svg";